import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import Fab from "@common/externos/components/fab/fab.externo";
import { Row, Col } from "react-bootstrap";
import api from "../service/deca.service";
import Typography from "@material-ui/core/Typography";
import decaActions from "../store/deca.actions";
import ModalInstitucional from "@/modules/common/institucionalModal/containers/institucional.modal";

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modulos: [],
      ativo: false,
    };
  }

  async componentDidMount() {
    const responseSistemas = await api.getsistemasHabilitadosPortalCidadao();
    let deca = responseSistemas.data.find(x => x.Nome == "DECA");

    const response = await api.getModulosAtivosByIdSistema();
    this.setState({ modulos: response.data, ativo: deca?.Ativo == 'Sim' });
  }

  redirect({ Alias, State: name }) {
    const { routerManager } = this.props;

    if (Alias === "Consultar")
      return routerManager.redirect({ name: "deca.consultasolicitacao" });

    routerManager.redirect({ name });
  }

  render() {
    const { modulos, ativo } = this.state;

    if (!ativo)
      return (
        <div className="text-center text-muted p-5">
          <Typography>Sistema desabilitado.</Typography>
        </div>
      );

    if (!modulos.length)
      return (
        <div className="text-center text-muted p-5">
          <Typography>Não existem módulos habilitados para a DECA.</Typography>
        </div>
      );

    return (
      <>
        <ModalInstitucional/>
        <Row>
          {modulos.map((modulo, index) => modulo.Ativo && (
            <Col xs={12} lg={4} key={index}>
              <Fab
                title={modulo.Nome}
                icon={`fas fa-${modulo.Icone}`}
                onClick={() => this.redirect(modulo)}
              />
            </Col>
          ))}

          <Col xd={12} lg={4}>
            <Fab
              title={"Manual"}
              icon={`fas fa-file-pdf`}
              onClick={() => {
                // window.open(
                //   "https://drive.google.com/open?id=1k8V15hPeY4lYXkQbHC1M0rSDJWxAr874"
                // )
                this.props.decaActions.getManual();
              }}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default connect({
  actions: {
    decaActions
  }
})(Container);
